import ReactNativeHapticFeedback from "~/ui/haptic-feedback"

const options = {
  enableVibrateFallback: true,
  ignoreAndroidSystemSettings: false,
}

export const hapticTrigger = () => {
  try {
    ReactNativeHapticFeedback?.trigger?.("impactLight", options)
  } catch {
    // web stub / unsupported platform
  }
}
